import { render, staticRenderFns } from "./AiJobForm.vue?vue&type=template&id=596605f6&scoped=true&"
import script from "./AiJobForm.vue?vue&type=script&lang=js&"
export * from "./AiJobForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596605f6",
  null
  
)

export default component.exports